import { Subject } from "rxjs";
import { IConversationBase, IConversationEventHandlers } from "../";

export class InteractionEventClient {
  private _handlers: IConversationEventHandlers;

  private _agentJoinedSubject = new Subject<string>();
  private _agentHeldSubject = new Subject<string>();
  private _alertedSubject = new Subject<string>();
  private _startedSubject = new Subject<IConversationBase>();
  private _endingSubject = new Subject<string>();
  private _endedSubject = new Subject<string>();
  private _transferringSubject = new Subject<string>();
  private _transferredSubject = new Subject<string>();
  private _customerJoinedSubject = new Subject<string>();

  public agentJoined$ = this._agentJoinedSubject.asObservable();
  public agentHeld$ = this._agentHeldSubject.asObservable();
  public alerted$ = this._alertedSubject.asObservable();
  public started$ = this._startedSubject.asObservable();
  public ending$ = this._endingSubject.asObservable();
  public ended$ = this._endedSubject.asObservable();
  public transferring$ = this._transferringSubject.asObservable();
  public transferred$ = this._transferredSubject.asObservable();
  public customerJoined$ = this._customerJoinedSubject.asObservable();

  constructor() {
    this._handlers = {
      agentJoined: (e) => this._agentJoinedSubject.next(e),
      customerJoined: (e) => this._customerJoinedSubject.next(e),
      agentHeld: (e) => this._agentHeldSubject.next(e),
      alerted: (e) => this._alertedSubject.next(e),
      started: (e) => this._startedSubject.next(e),
      ending: (e) => this._endingSubject.next(e),
      ended: (e) => this._endedSubject.next(e),
      transferring: (e) => this._transferringSubject.next(e),
      transferred: (e) => this._transferredSubject.next(e),
    };
  }

  public getHandlers(): IConversationEventHandlers {
    return this._handlers;
  }
}
